export const lastDayOfMonth = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + 1, 0); // Set to the last day of the next month
  return newDate;
};
